import { AiRateIndicator } from "./AiRateIndicator";

import type { IHeaderParams } from "ag-grid-community";
import type { AxiosInstance } from "axios";
import type { FC } from "react";
import type { AiRateFieldsMeta } from "../../../types/models";

export interface AiRateHeaderProps extends IHeaderParams {
  /** Combined AI extraction metadata for this plan's rate-area fields */
  aiFields?: AiRateFieldsMeta;
  /** Axios instance for downloading documents from the popover */
  axiosInstance?: AxiosInstance;
}

/**
 * Inner header component for plan columns. Renders the plan header label and,
 * when AI rate extraction data exists, the AI corner indicator on the plan
 * header row rather than the cell body (CD-1694). The indicator anchors to the
 * enclosing `.ag-header-cell`, which AG Grid positions absolutely, so the
 * triangle sits flush in the header's top-left corner regardless of padding.
 */
export const AiRateHeader: FC<AiRateHeaderProps> = ({
  displayName,
  aiFields,
  axiosInstance,
}) => {
  // Only mount the indicator (and its hooks) when there's extraction data to
  // show, since this renders once per plan column.
  const hasAiData = Boolean(aiFields?.rate || aiFields?.enrolledLives);
  return (
    <>
      {hasAiData && (
        <AiRateIndicator aiFields={aiFields} axiosInstance={axiosInstance} />
      )}
      {displayName}
    </>
  );
};
